var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91774 20H16.3497C18.8337 20 19.8237 18.479 19.9407 16.625L20.4087 9.191C20.5347 7.247 18.9867 5.6 17.0337 5.6C16.4847 5.6 15.9807 5.285 15.7287 4.799L15.0807 3.494C14.6667 2.675 13.5867 2 12.6687 2H10.6077C9.68074 2 8.60074 2.675 8.18674 3.494L7.53874 4.799C7.28674 5.285 6.78274 5.6 6.23374 5.6C4.28074 5.6 2.73274 7.247 2.85874 9.191L3.32674 16.625C3.43474 18.479 4.43374 20 6.91774 20Z",
    stroke: "#EE750A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2832 7.40002H12.9832",
    stroke: "#EE750A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6335 16.3999C13.2445 16.3999 14.5585 15.0859 14.5585 13.4749C14.5585 11.8639 13.2445 10.5499 11.6335 10.5499C10.0225 10.5499 8.7085 11.8639 8.7085 13.4749C8.7085 15.0859 10.0225 16.3999 11.6335 16.3999Z",
    stroke: "#EE750A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.99f216c94130c4afe3d76dd45b8488f7.svg";
export { ForwardRef as ReactComponent };